import { Icone } from './ui';
import { ACCENT, ACCENT_FOND, OMBRE_CARTE, RAYON_CARTE, SURFACE, TEXTE, TEXTE_MUET } from '../theme';

function initiales(nom) {
  const mots = (nom || '').trim().split(/\s+/).filter(Boolean);
  if (mots.length === 0) return '?';
  return (mots[0][0] + (mots[1]?.[0] || '')).toUpperCase();
}

/** Carte atelier (niveau 1 confection) : avatar-initiales, nom, code usine.
 * Hauteur MINIMALE, jamais fixe : un nom d'atelier long passe à la ligne au lieu de déborder. */
export default function CarteSousTraitant({ sousTraitant, onClick }) {
  const nom = sousTraitant.name || sousTraitant.fullName;
  return (
    <button
      type="button"
      className="aqs-carte"
      onClick={onClick}
      style={{
        textAlign: 'left', padding: 20, minHeight: 140, minWidth: 0, background: SURFACE, border: 'none',
        borderRadius: RAYON_CARTE, cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 16,
        boxShadow: OMBRE_CARTE, color: TEXTE,
      }}
    >
      <div
        style={{
          width: 48, height: 48, borderRadius: '50%', flex: 'none', background: ACCENT_FOND, color: ACCENT,
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, fontWeight: 650, letterSpacing: '0.01em',
        }}
      >
        {initiales(nom)}
      </div>
      <div style={{ marginTop: 'auto', display: 'flex', alignItems: 'flex-end', gap: 10, width: '100%', minWidth: 0 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="aqs-titre" style={{ fontSize: 18, fontWeight: 650, letterSpacing: '-0.01em', lineHeight: 1.25 }}>{nom}</div>
          <div style={{ marginTop: 3, fontSize: 14, color: TEXTE_MUET }}>{sousTraitant.codeUsine || `#${sousTraitant.id}`}</div>
        </div>
        <span className="aqs-carte-fleche" style={{ color: TEXTE_MUET, display: 'inline-flex' }}><Icone.ChevronDroite taille={20} /></span>
      </div>
    </button>
  );
}
